import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../../../shared/shared.service';
import { Util } from '../../../../../utils/util';
import { PixQrCodeDynamicService } from '../../../copy-and-paste/qr-code-dynamic/qr-code-dynamic.service';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { ETipoOperacao, PixQrCodeReturn } from '../../../models/qr-code-return.model';
import { PixPaymentKeyService } from '../../../payment-key/payment-key.service';
import { WithdrawChangeService } from '../../service/withdraw-change.service';

@Component({
	selector: 'app-value-date',
	templateUrl: './value-date.component.html',
	styleUrls: ['./value-date.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixWithdrawChangeValueDateComponent implements OnInit {

	public form: FormGroup;
	public submited = false;
	public minDate = new Date(new Date());
	public maxDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
	public selectedPixPaymentFavoredView: PixPaymentFavoredView;
	public saldoSaque = 9999999999999;
	public saldoParcial = 9999999999999;
	public limiteDisponivel = 9999999999999;
	public pixQrCodeReturn: PixQrCodeReturn;
	public pixQrCodeStaticReturn: PixPaymentFavoredView;
	public showBalanceLimit = false;

	get isWithdraw(): boolean{
		if (this.pixQrCodeReturn && this.pixQrCodeReturn.qrCodeDinamico) {
			return this.pixQrCodeReturn.qrCodeDinamico.tipoOperacao === ETipoOperacao.SAQUE;
		}

		if (this.pixQrCodeStaticReturn)	{
			return this.pixQrCodeStaticReturn.tipoOperacao === ETipoOperacao.SAQUE;
		}
	}

	get purchaseValue(): string{
		if (this.pixQrCodeReturn && this.pixQrCodeReturn.qrCodeDinamico) {
			if(this.pixQrCodeReturn.qrCodeDinamico.troco !== undefined){
				return this.pixQrCodeReturn.qrCodeDinamico.troco.compra.toString();
			}
			return '';
		}
		return '';
	}

	get totalValue(): string{
		if (this.pixQrCodeReturn) {
			return (this.pixQrCodeReturn.qrCodeDinamico.troco.compra + this.form.get('value').value).toString();
		}

		return '';
	}

	get title(): string{
		if (this.isWithdraw) {
			return 'Qual é o valor que você deseja sacar';
		}

		return 'Digite o valor do troco';
	}

	get mainTitle(): string{
		if (this.isWithdraw) {
			return 'Pix Saque';
		}

		return 'Pix Troco';
	}

	get placeHolder(): string{
		if (this.isWithdraw) {
			return 'Valor do saque';
		}

		return 'Valor do troco';
	}

	constructor(
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private router: Router,
		public dialog: MatDialog,
		private sharedService: SharedService,
		private pixQrCodeDynamicService: PixQrCodeDynamicService,
		private withdrawChangeService: WithdrawChangeService,
		private pixPaymentKeyService: PixPaymentKeyService
	) {}

	ngOnInit(): void {

		this.pixQrCodeReturn = this.pixQrCodeDynamicService.getSelectedPixQrCodeReturn();
		this.pixQrCodeStaticReturn = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();

		this.buildForm();
		this.getBalance();
	}

	getBalance() {
		this.sharedService.getBalance().subscribe( (data: any) => {
			this.saldoSaque = data.Retorno.SaldoSaque;
			this.saldoParcial = data.Retorno.SaldoParcial;
			this.limiteDisponivel = data.Retorno.LimiteDisponivel;
		});
	}

	buildForm() {
		let value: number;

		value = this.getInputValue();

		const date = new Date();

		this.form = this.formBuilder.group({
			name: this.getName(),
			value: [value === 0 ? '' : value, [Validators.required, Validators.min(0.01), Validators.max(999999)]],
		});

		this.withdrawChangeService.setValue(value);

		console.log(this.pixQrCodeReturn);
		console.log(this.checkExchangeModality());

		if (!this.checkExchangeModality() || this.pixQrCodeStaticReturn) {
			if (value > 0 || this.pixQrCodeReturn.qrCodeDinamico.troco && this.pixQrCodeReturn.qrCodeDinamico.troco.troca === 0) {
				this.form.get('value').disable();
			}
		}
	}

	private getInputValue(): number {
		let value: number;

		if (this.pixQrCodeReturn) {
			if (this.isWithdraw && this.pixQrCodeReturn.qrCodeDinamico.saque) {
				value = this.pixQrCodeReturn.valor;
			}

			if (this.pixQrCodeReturn.qrCodeDinamico.troco) {
				value = this.pixQrCodeReturn.qrCodeDinamico.troco.troca;
			}
		}

		if (this.pixQrCodeStaticReturn) {
			value = this.pixQrCodeStaticReturn.valorQrCode;
		}

		return value;
	}

	submit() {
		if (this.form.valid) {
			const value = this.form.get('value').value;

			if (this.pixQrCodeReturn && this.checkExchangeModality()) {
				if (this.isWithdraw) {
					this.pixQrCodeReturn.valor = value;
				}else {
					this.pixQrCodeReturn.qrCodeDinamico.troco.troca = value;
					this.pixQrCodeReturn.valor = this.pixQrCodeReturn.qrCodeDinamico.troco.troca + this.pixQrCodeReturn.qrCodeDinamico.troco.compra;
				}
			}

			if (this.pixQrCodeStaticReturn && this.pixQrCodeStaticReturn.valorQrCode === 0) {
				this.pixQrCodeStaticReturn.valorTransferir = value;
			}

			this.router.navigate(['pix/pagamento/saque-e-troco/pix-copia-cola/resumo']);
		}
	}

	verifyZero() {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	showInfoSaldo(): boolean {
		const availableBalance = this.availableBalanceValue();
		const value = this.inputValue();

		this.showBalanceLimit = false;
		if (availableBalance + this.limiteDisponivel >= value) {
			this.showBalanceLimit = true;
		}

		if(this.saldoParcial >= 0){
			return ((value > availableBalance || parseFloat(this.purchaseValue) > availableBalance) && !this.showBalanceLimit);
		} else { //Limite negativo
			const limit = this.whenNegativeLimitValue();

			if (value > limit)
				this.showBalanceLimit = false;

			return (value > limit);
		}
  }

  getTextSaldo(): string {
		this.showBalanceLimit = false;
		return `Você não possui saldo disponível para realizar este pagamento`;
  }

	showInfoSaldoLimiteOmniPlus(): boolean {
		const availableBalance = this.availableBalanceValue();
		const inputValue = this.inputValue();

		if(inputValue > availableBalance || parseFloat(this.purchaseValue) || this.limiteDisponivel > 0 || this.saldoParcial < 0){
			if(availableBalance < inputValue || this.saldoParcial < 0){

				if(this.saldoParcial >= 0){
					return availableBalance + this.limiteDisponivel >= inputValue && this.limiteDisponivel > 0;
				} else { //Limite negativo
					const limit = this.whenNegativeLimitValue();
					return limit >= inputValue;
				}
			}
		}

		return false;
  }

	getTextSaldoLimiteOmniPlus(): string {
		this.showBalanceLimit = true;
		return `Nesta operação você utilizará <b>${this.getLimitValue()}</b> do seu <b>Limite Omni Plus</b> e estará sujeito a cobrança de encargos proporcionais aos dias de uso do limite.`;
	}

	getLimitValue(): string {
		const availableBalance = this.availableBalanceValue();
		const inputValue = this.inputValue();
		return this.saldoParcial >= 0 ? Util.formatValue(inputValue - availableBalance) : Util.formatValue(inputValue + availableBalance);
	}

	availableBalanceValue(): number {
		if(!isNaN(parseFloat(this.purchaseValue))){
			return this.saldoParcial >= 0 ? this.saldoParcial - parseFloat(this.purchaseValue) : parseFloat(this.purchaseValue);
		} else {
			return this.saldoParcial >= 0 ? this.saldoParcial : 0;
		}
	}

	inputValue(): number {
		return this.form.get('value').value;
	}

	whenNegativeLimitValue(): number {
		const availableBalance = this.availableBalanceValue();
		const limit = this.limiteDisponivel - availableBalance;
		return parseFloat(limit.toFixed(2));
	}

	goBack = () => this.router.navigate(['pix/pagamento/saque-e-troco/pix-copia-cola']);
	goNext = () => this.router.navigate(['pix/pagamento/saque-e-troco/pix-copia-cola/resumo']);
	getName = () => this.selectedPixPaymentFavoredView === undefined ? '' : this.selectedPixPaymentFavoredView.nome;

	private checkExchangeModality(): boolean {
		if (this.pixQrCodeReturn && this.pixQrCodeReturn.qrCodeDinamico) {
			return ((this.pixQrCodeReturn.qrCodeDinamico.troco && this.pixQrCodeReturn.qrCodeDinamico.troco.modalidadeTroca === 'S')
				|| (this.pixQrCodeReturn.qrCodeDinamico.saque && this.pixQrCodeReturn.qrCodeDinamico.saque.modalidadeTroca === 'S'));
		}

		return false;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/copy-and-paste/value-date/value-date.component.ts